var _rect, _g, _g2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFlatLeft(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "436.8px",
    height: "566.9px",
    viewBox: "0 0 436.8 566.9",
    enableBackground: "new 0 0 436.8 566.9",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 245.6,
    y: 183,
    fill: "#494848",
    width: 0,
    height: 69.9
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    fill: "#878787",
    stroke: "#878787",
    strokeWidth: 1.2079,
    strokeMiterlimit: 10,
    cx: 57.7,
    cy: 105.4,
    r: 2.9
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#878787",
    stroke: "#878787",
    strokeWidth: 1.2079,
    strokeMiterlimit: 10,
    cx: 57.7,
    cy: 117,
    r: 2.9
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#878787",
    stroke: "#878787",
    strokeWidth: 1.2079,
    strokeMiterlimit: 10,
    cx: 57.7,
    cy: 128.7,
    r: 2.9
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#878787",
    stroke: "#878787",
    strokeWidth: 1.2079,
    strokeMiterlimit: 10,
    cx: 57.7,
    cy: 140.4,
    r: 2.9
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#878787",
    stroke: "#878787",
    strokeWidth: 1.2079,
    strokeMiterlimit: 10,
    cx: 57.7,
    cy: 152,
    r: 2.9
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#878787",
    stroke: "#878787",
    strokeWidth: 1.2079,
    strokeMiterlimit: 10,
    cx: 57.7,
    cy: 163.7,
    r: 2.9
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#878787",
    stroke: "#878787",
    strokeWidth: 1.2079,
    strokeMiterlimit: 10,
    cx: 57.7,
    cy: 175.4,
    r: 2.9
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#878787",
    stroke: "#878787",
    strokeWidth: 1.2079,
    strokeMiterlimit: 10,
    cx: 57.7,
    cy: 187,
    r: 2.9
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#878787",
    stroke: "#878787",
    strokeWidth: 1.2079,
    strokeMiterlimit: 10,
    cx: 57.7,
    cy: 198.7,
    r: 2.9
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#878787",
    stroke: "#878787",
    strokeWidth: 1.2079,
    strokeMiterlimit: 10,
    cx: 57.7,
    cy: 210.3,
    r: 2.9
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#878787",
    stroke: "#878787",
    strokeWidth: 1.2079,
    strokeMiterlimit: 10,
    cx: 57.7,
    cy: 222,
    r: 2.9
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#878787",
    stroke: "#878787",
    strokeWidth: 1.2079,
    strokeMiterlimit: 10,
    cx: 57.7,
    cy: 233.7,
    r: 2.9
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#878787",
    stroke: "#878787",
    strokeWidth: 1.2079,
    strokeMiterlimit: 10,
    cx: 57.7,
    cy: 245.3,
    r: 2.9
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#878787",
    stroke: "#878787",
    strokeWidth: 1.2079,
    strokeMiterlimit: 10,
    cx: 57.7,
    cy: 257,
    r: 2.9
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#878787",
    stroke: "#878787",
    strokeWidth: 1.2079,
    strokeMiterlimit: 10,
    cx: 57.7,
    cy: 268.7,
    r: 2.9
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#878787",
    stroke: "#878787",
    strokeWidth: 1.2079,
    strokeMiterlimit: 10,
    cx: 57.7,
    cy: 280.3,
    r: 2.9
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#878787",
    stroke: "#878787",
    strokeWidth: 1.2079,
    strokeMiterlimit: 10,
    cx: 57.7,
    cy: 292,
    r: 2.9
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#878787",
    stroke: "#878787",
    strokeWidth: 1.2079,
    strokeMiterlimit: 10,
    cx: 57.7,
    cy: 303.7,
    r: 2.9
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#878787",
    stroke: "#878787",
    strokeWidth: 1.2079,
    strokeMiterlimit: 10,
    cx: 57.7,
    cy: 315.3,
    r: 2.9
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#878787",
    stroke: "#878787",
    strokeWidth: 1.2079,
    strokeMiterlimit: 10,
    cx: 57.7,
    cy: 327,
    r: 2.9
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#878787",
    stroke: "#878787",
    strokeWidth: 1.2079,
    strokeMiterlimit: 10,
    cx: 57.7,
    cy: 338.7,
    r: 2.9
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#878787",
    stroke: "#878787",
    strokeWidth: 1.2079,
    strokeMiterlimit: 10,
    cx: 57.7,
    cy: 350.3,
    r: 2.9
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#878787",
    stroke: "#878787",
    strokeWidth: 1.2079,
    strokeMiterlimit: 10,
    cx: 57.7,
    cy: 362,
    r: 2.9
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#878787",
    stroke: "#878787",
    strokeWidth: 1.2079,
    strokeMiterlimit: 10,
    cx: 57.7,
    cy: 373.7,
    r: 2.9
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#878787",
    stroke: "#878787",
    strokeWidth: 1.2079,
    strokeMiterlimit: 10,
    cx: 57.7,
    cy: 385.3,
    r: 2.9
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#878787",
    stroke: "#878787",
    strokeWidth: 1.2079,
    strokeMiterlimit: 10,
    cx: 57.7,
    cy: 397,
    r: 2.9
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#878787",
    stroke: "#878787",
    strokeWidth: 1.2079,
    strokeMiterlimit: 10,
    cx: 57.7,
    cy: 408.7,
    r: 2.9
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#878787",
    stroke: "#878787",
    strokeWidth: 1.2079,
    strokeMiterlimit: 10,
    cx: 57.7,
    cy: 420.3,
    r: 2.9
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#878787",
    stroke: "#878787",
    strokeWidth: 1.2079,
    strokeMiterlimit: 10,
    cx: 57.7,
    cy: 432,
    r: 2.9
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#878787",
    stroke: "#878787",
    strokeWidth: 1.2079,
    strokeMiterlimit: 10,
    cx: 57.7,
    cy: 443.7,
    r: 2.9
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#878787",
    stroke: "#878787",
    strokeWidth: 1.2079,
    strokeMiterlimit: 10,
    cx: 59.4,
    cy: 455.3,
    r: 2.9
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    fill: "#878787",
    stroke: "#878787",
    strokeWidth: 1.2079,
    strokeMiterlimit: 10,
    cx: 68.9,
    cy: 105.4,
    r: 2.9
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#878787",
    stroke: "#878787",
    strokeWidth: 1.2079,
    strokeMiterlimit: 10,
    cx: 68.9,
    cy: 117,
    r: 2.9
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#878787",
    stroke: "#878787",
    strokeWidth: 1.2079,
    strokeMiterlimit: 10,
    cx: 68.9,
    cy: 128.7,
    r: 2.9
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#878787",
    stroke: "#878787",
    strokeWidth: 1.2079,
    strokeMiterlimit: 10,
    cx: 68.9,
    cy: 140.4,
    r: 2.9
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#878787",
    stroke: "#878787",
    strokeWidth: 1.2079,
    strokeMiterlimit: 10,
    cx: 68.9,
    cy: 152,
    r: 2.9
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#878787",
    stroke: "#878787",
    strokeWidth: 1.2079,
    strokeMiterlimit: 10,
    cx: 68.9,
    cy: 163.7,
    r: 2.9
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#878787",
    stroke: "#878787",
    strokeWidth: 1.2079,
    strokeMiterlimit: 10,
    cx: 68.9,
    cy: 175.4,
    r: 2.9
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#878787",
    stroke: "#878787",
    strokeWidth: 1.2079,
    strokeMiterlimit: 10,
    cx: 68.9,
    cy: 187,
    r: 2.9
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#878787",
    stroke: "#878787",
    strokeWidth: 1.2079,
    strokeMiterlimit: 10,
    cx: 68.9,
    cy: 198.7,
    r: 2.9
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#878787",
    stroke: "#878787",
    strokeWidth: 1.2079,
    strokeMiterlimit: 10,
    cx: 68.9,
    cy: 210.3,
    r: 2.9
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#878787",
    stroke: "#878787",
    strokeWidth: 1.2079,
    strokeMiterlimit: 10,
    cx: 68.9,
    cy: 222,
    r: 2.9
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#878787",
    stroke: "#878787",
    strokeWidth: 1.2079,
    strokeMiterlimit: 10,
    cx: 68.9,
    cy: 233.7,
    r: 2.9
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#878787",
    stroke: "#878787",
    strokeWidth: 1.2079,
    strokeMiterlimit: 10,
    cx: 68.9,
    cy: 245.3,
    r: 2.9
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#878787",
    stroke: "#878787",
    strokeWidth: 1.2079,
    strokeMiterlimit: 10,
    cx: 68.9,
    cy: 257,
    r: 2.9
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#878787",
    stroke: "#878787",
    strokeWidth: 1.2079,
    strokeMiterlimit: 10,
    cx: 68.9,
    cy: 268.7,
    r: 2.9
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#878787",
    stroke: "#878787",
    strokeWidth: 1.2079,
    strokeMiterlimit: 10,
    cx: 68.9,
    cy: 280.3,
    r: 2.9
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#878787",
    stroke: "#878787",
    strokeWidth: 1.2079,
    strokeMiterlimit: 10,
    cx: 68.9,
    cy: 292,
    r: 2.9
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#878787",
    stroke: "#878787",
    strokeWidth: 1.2079,
    strokeMiterlimit: 10,
    cx: 68.9,
    cy: 303.7,
    r: 2.9
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#878787",
    stroke: "#878787",
    strokeWidth: 1.2079,
    strokeMiterlimit: 10,
    cx: 68.9,
    cy: 315.3,
    r: 2.9
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#878787",
    stroke: "#878787",
    strokeWidth: 1.2079,
    strokeMiterlimit: 10,
    cx: 68.9,
    cy: 327,
    r: 2.9
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#878787",
    stroke: "#878787",
    strokeWidth: 1.2079,
    strokeMiterlimit: 10,
    cx: 68.9,
    cy: 338.7,
    r: 2.9
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#878787",
    stroke: "#878787",
    strokeWidth: 1.2079,
    strokeMiterlimit: 10,
    cx: 68.9,
    cy: 350.3,
    r: 2.9
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#878787",
    stroke: "#878787",
    strokeWidth: 1.2079,
    strokeMiterlimit: 10,
    cx: 68.9,
    cy: 362,
    r: 2.9
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#878787",
    stroke: "#878787",
    strokeWidth: 1.2079,
    strokeMiterlimit: 10,
    cx: 68.9,
    cy: 373.7,
    r: 2.9
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#878787",
    stroke: "#878787",
    strokeWidth: 1.2079,
    strokeMiterlimit: 10,
    cx: 68.9,
    cy: 385.3,
    r: 2.9
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#878787",
    stroke: "#878787",
    strokeWidth: 1.2079,
    strokeMiterlimit: 10,
    cx: 68.9,
    cy: 397,
    r: 2.9
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#878787",
    stroke: "#878787",
    strokeWidth: 1.2079,
    strokeMiterlimit: 10,
    cx: 68.9,
    cy: 408.7,
    r: 2.9
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#878787",
    stroke: "#878787",
    strokeWidth: 1.2079,
    strokeMiterlimit: 10,
    cx: 68.9,
    cy: 420.3,
    r: 2.9
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#878787",
    stroke: "#878787",
    strokeWidth: 1.2079,
    strokeMiterlimit: 10,
    cx: 68.9,
    cy: 432,
    r: 2.9
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#878787",
    stroke: "#878787",
    strokeWidth: 1.2079,
    strokeMiterlimit: 10,
    cx: 68.9,
    cy: 443.7,
    r: 2.9
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    stroke: "#706F6F",
    strokeWidth: 1.2079,
    strokeMiterlimit: 10,
    d: "M66,498.3h-4.8c-1.8,0-3.2-1.5-3.2-3.2 v-30.3c0-1.8,1.5-3.2,3.2-3.2H66c1.8,0,3.2,1.5,3.2,3.2V495C69.3,496.8,67.8,498.3,66,498.3z"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#878787",
    strokeWidth: 1.2079,
    strokeMiterlimit: 10,
    d: "M57.7,102.4v352.1l11.2-1.4 c0-8.7,0-350.6,0-350.6H57.7z"
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#878787",
    stroke: "#878787",
    strokeWidth: 1.2079,
    strokeMiterlimit: 10,
    cx: 68.9,
    cy: 453.6,
    r: 2.9
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#E3E3E2",
    stroke: "#626262",
    strokeWidth: 1.7439,
    strokeMiterlimit: 10,
    d: "M37.1,382c0,0,0,4.5-0.7,6.5 c-1.2,3.1,0.9,4,0.9,4H400c0,0,1.9-0.5,0.9-3.5c-0.7-3.8-1.2-7-1.2-7H37.1L37.1,382z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#E3E3E2",
    stroke: "#626262",
    strokeWidth: 1.7439,
    strokeMiterlimit: 10,
    d: "M37.1,372.8c0,0,0.2,3.3-0.7,6.5 c-1.9,4,0.9,4,0.9,4H400c0,0,1.9-0.5,0.9-3.5c-0.7-3.8-1.2-7-1.2-7H37.1L37.1,372.8z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#E3E3E2",
    stroke: "#626262",
    strokeWidth: 1.7439,
    strokeMiterlimit: 10,
    d: "M41.7,63.1h358.7L399.9,313 c0,0,0.2,1.9,0,7.5c0.9,3.3,1.7,52.8-0.9,52.8c-2.8,0-353.5,0-360.6,0c-5.1,0-1.6-48.7-2.1-58.9c0-2.4,0-251.3,0-251.3L41.7,63.1 L41.7,63.1z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFlatLeft);
export default __webpack_public_path__ + "static/media/flat_left.ac2a0dbeac3aaa10dfcee2d058853935.svg";
export { ForwardRef as ReactComponent };